import React, { useState } from "react";

function Prompt({ prompt, setPrompt }) {
	const suggestionPrompts = [
		"Опиши исследование",
		"Расшифруй результаты исследования",
	];
	const handleChange = (event) => {
		setPrompt(event.target.value);
	};
	const handleSuggestClick = (suggest) => setPrompt(suggest);

	return (
		<div className='prompt-container'>
			<textarea
				id='aiPrompt'
				placeholder='Введите запрос к ИИ для анализа загруженного файла...'
				value={prompt}
				onChange={handleChange}
				rows='5' // Optional: specify initial number of rows
				cols='40' // Optional: specify initial number of columns
			/>
			<div className='suggest-prompts'>
				<div className='title'>Шаблоны: </div>
				{suggestionPrompts.map((suggest) => (
					<div className='suggest' onClick={() => handleSuggestClick(suggest)}>
						{suggest}
					</div>
				))}
			</div>
		</div>
	);
}

export default Prompt;
